import { GOOGLE_SATELLITE } from '@carto/react-basemaps';
import { API_VERSIONS } from '@deck.gl/carto';
import { createSearchParams } from 'react-router-dom';

export const initialViewState = {
  longitude: 123.91942779001192,
  latitude: 10.480209542606863,
  zoom: 4,
  pitch: 0,
  bearing: 0,
  dragRotate: false,
  maxZoom: 18,
};
// Set initial state based on query params. This is here to gurantee this is only set manually on app load
// After app load, query params is programtically set
let searchParams = createSearchParams(window.location.search);
const longitude = parseFloat(searchParams.get('longitude'));
const latitude = parseFloat(searchParams.get('latitude'));
const zoom = parseInt(searchParams.get('zoom'));
export const initialState = {
  viewState: {
    ...initialViewState,
    longitude: isNaN(longitude) ? initialViewState.longitude : longitude,
    latitude: isNaN(latitude) ? initialViewState.latitude : latitude,
    zoom: isNaN(zoom) ? initialViewState.zoom : zoom,
  },
  basemap: GOOGLE_SATELLITE,
  credentials: {
    apiVersion: API_VERSIONS.V3,
    apiBaseUrl: 'https://gcp-us-east1.api.carto.com',
  },
  googleApiKey: process.env.REACT_APP_GOOGLE_API_KEY, // only required when using a Google Basemap
  googleMapId: '', // only required when using a Google Custom Basemap
  // oauth: {
  //   domain: 'auth.carto.com',
  //   // Type here your application client id
  //   clientId: '',
  //   scopes: [
  //     'read:current_user',
  //     'update:current_user',
  //     'read:connections',
  //     'write:connections',
  //     'read:maps',
  //     'write:maps',
  //     'read:account',
  //     'admin:account',
  //   ],
  //   audience: 'carto-cloud-native-api',
  //   authorizeEndPoint: 'https://carto.com/oauth2/authorize', // only valid if keeping https://localhost:3000/oauthCallback
  // },
};
